import styled from "styled-components";

export const RoomInfoStyled = styled.div`
  .room_info_row {
    margin-bottom: 18px;
    display: flex;
    column-gap: 30px;
    .room_info_head {
      flex-basis: 250px;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
    .room_info_detail {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
  }

  .theme_standard {
  }
`;
